<template>
  <div v-if="noParentGroup">
    <div
      class="_text-center no-oe"
      container
    >
      <div class="_mtm">
        <h1
          v-if="$store.state.cloudCannon.cloudCannonContent.oeAccessTitle"
          class="_mbs"
        >
          {{ $store.state.cloudCannon.cloudCannonContent.oeAccessTitle }}
        </h1>
        <p v-if="$store.state.cloudCannon.cloudCannonContent.oeAccessDescription" v-html="$store.state.cloudCannon.cloudCannonContent.oeAccessDescription">
        </p>
        <router-link
          to="/dashboard"
          tag="button"
          class="_mts"
        >
          Return to your Dashboard
        </router-link>
      </div>
    </div>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
  import { computed }  from '@vue/composition-api'; 
  import { useStore } from '@vue3shims';
  export default {
    setup() {
      const store = useStore();
      const noParentGroup = computed(() => store.getters['groupSelector/parentGroup'] === null);

      return {
        noParentGroup,
      }
    },
    props: {
      parentGroupCk: {
        type: String,
        required: false
      }
    }
  }
</script>

<style lang="scss">
  .no-oe {
    padding: 3rem 0;
  }
</style>
